import React from "react";

// Map every booking status the API can return (payment-pending,
// request-pending, rejected, accepted, completed, cancelled) to a labelled
// badge, so the Status column always shows a clear value instead of a bare
// icon or — worse — an empty cell.
const STATUS_MAP: Record<string, { label: string; cls: string }> = {
  "payment-pending": { label: "Payment Pending", cls: "status-draft" },
  "request-pending": { label: "Request Pending", cls: "status-draft" },
  accepted: { label: "Confirmed", cls: "status-published" },
  completed: { label: "Completed", cls: "status-published" },
  rejected: { label: "Rejected", cls: "status-blocked" },
  cancelled: { label: "Cancelled", cls: "status-blocked" },
};

export const renderBookingStatus = (status?: string) => {
  const normalized = String(status || "").toLowerCase();
  const entry = STATUS_MAP[normalized];

  if (!entry) {
    return <span className="text-muted">—</span>;
  }

  return <span className={`status-badge ${entry.cls}`}>{entry.label}</span>;
};
